<template>
  <div class="devices-events-container">
    <div class="section-header">
      <h4 class="section-title">
        {{ $t("globals.events") }}:
        <v-icon v-if="eventsSearchLoading" name="spinner" spin></v-icon>
      </h4>
      <div class="pagination-controls" v-if="events_stats.length > 0">
        <button
          class="page-btn"
          :disabled="currentPage === 1"
          @click="currentPage--"
        >
          &lt;
        </button>
        <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
        <button
          class="page-btn"
          :disabled="currentPage >= totalPages"
          @click="currentPage++"
        >
          &gt;
        </button>
      </div>
    </div>
    <div class="table-wrapper" style="position: relative; min-height: 200px;">
      <div v-if="eventsSearchLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ $t("globals.loading") }}...</p>
      </div>
      <table class="modern-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Dongel</th>
            <th>Blackbox</th>
            <th>Old CT</th>
            <th>Blackbox 4G</th>
            <th>Dongel 4G</th>
            <th>CMM1</th>
            <th>CMM3</th>
            <th>CMM4</th>
            <th>AT4M</th>
            <th>TW Dashcam</th>
            <th>Velcare</th>
            <th>Velcare VB</th>
            <th>RNET</th>
            <th>All</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedEvents" :key="item.type + currentPage">
            <td>
              <span :class="[eventTypeVariant(item.type)]">{{ item.type }}</span>
            </td>
            <td>{{ item.dongel }}</td>
            <td>{{ item.blackbox }}</td>
            <td>{{ item.old_ct }}</td>
            <td>{{ item.blackbox4g }}</td>
            <td>{{ item.dongel4g }}</td>
            <td>{{ item.cmm1 }}</td>
            <td>{{ item.cmm3 }}</td>
            <td>{{ item.cmm4 }}</td>
            <td>{{ item.at4m }}</td>
            <td>{{ item.twdashcam }}</td>
            <td>{{ item.velcare }}</td>
            <td>{{ item.velcare_vb }}</td>
            <td>{{ item.rnet }}</td>
            <td>{{ item.all }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!eventsSearchLoading && events_stats.length === 0" class="empty-state">
        <p>{{ $t("globals.no_results") }}</p>
      </div>
    </div>
    <div class="filters-section">
      <div class="quick-filters">
        <div class="filter-group-label">Quick Filters:</div>
        <div class="button-groups">
          <div class="button-group">
            <button class="filter-btn filter-btn-outline" @click="lastYear">P. year</button>
            <button class="filter-btn filter-btn-active" @click="thisYear">T. year</button>
          </div>
          <div class="button-group">
            <button class="filter-btn filter-btn-outline" @click="lastQuarter">P. Q</button>
            <button class="filter-btn filter-btn-active" @click="thisQuarter">T. Q</button>
          </div>
          <div class="button-group">
            <button class="filter-btn filter-btn-outline" @click="lastMonth">P. month</button>
            <button class="filter-btn filter-btn-active" @click="thisMonth">T. month</button>
          </div>
          <div class="button-group">
            <button class="filter-btn filter-btn-outline" @click="lastWeek">P. week</button>
            <button class="filter-btn filter-btn-active" @click="thisWeek">T. week</button>
          </div>
          <div class="button-group">
            <button class="filter-btn filter-btn-outline" @click="yesterday">Yesterday</button>
            <button class="filter-btn filter-btn-active" @click="today">Today</button>
          </div>
        </div>
      </div>
      <div class="date-filters">
        <b-form-datepicker
          class="date-picker"
          :placeholder="'Events from'"
          :state="Boolean(events_from)"
          v-model="events_from"
          :disabled="Boolean(events_from)"
        ></b-form-datepicker>
        <b-form-datepicker
          class="date-picker"
          :placeholder="'Events to'"
          :state="Boolean(events_to)"
          v-model="events_to"
          :min="new Date(events_from)"
          :disabled="events_from==null || events_to != null"
        ></b-form-datepicker>
      </div>
      <div class="action-buttons-row">
        <button class="action-btn clear-btn" @click="clear">
          {{ $t("globals.clear") }}
        </button>
        <button
          class="action-btn search-btn-green"
          @click="search"
          :disabled="events_from == null || events_to == null"
        >
          {{ $t("globals.search") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { startOfWeek, addDays } from "date-fns";

export default {
  data() {
    return {
      perPage: 3,
      currentPage: 1,
      now: new Date,
      eventsSearchLoading: false,
      events_from: null,
      events_to: null,
      events_stats: []
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    search() {
      const data = {
        query: `
          query {
            DevicesEventsStats (
              from: "${this.events_from}",
              to: "${this.events_to}"
            )
          }
        `
      };
      this.eventsSearchLoading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.events_stats = res.DevicesEventsStats.map(item => {
            return {
              type: item[0],
              dongel: item[1],
              blackbox: item[2],
              old_ct: item[3],
              blackbox4g: item[4],
              dongel4g: item[5],
              cmm1: item[6],
              cmm3: item[7],
              cmm4: item[8],
              at4m: item[9],
              twdashcam: item[10],
              velcare: item[11],
              velcare_vb: item[12],
              rnet: item[13],
              all: item[14]
            }
          })
        }
      }).finally(()=>{
        let row = {
          type: "sold_all",
          dongel: 0,
          blackbox: 0,
          old_ct: 0,
          blackbox4g: 0,
          dongel4g: 0,
          cmm1: 0,
          cmm3: 0,
          cmm4: 0,
          at4m: 0,
          twdashcam: 0,
          velcare: 0,
          velcare_vb: 0,
          rnet: 0,
          all: 0,
          _rowVariant: 'success'
        }

        this.events_stats.filter(el => el.type == 'sold' || el.type == 'sold_lease').forEach(el2 => {
          row.dongel += parseInt(el2.dongel);
          row.blackbox += parseInt(el2.blackbox);
          row.old_ct += parseInt(el2.old_ct);
          row.blackbox4g += parseInt(el2.blackbox4g);
          row.dongel4g += parseInt(el2.dongel4g);
          row.cmm1 += parseInt(el2.cmm1);
          row.cmm3 += parseInt(el2.cmm3);
          row.cmm4 += parseInt(el2.cmm4);
          row.at4m += parseInt(el2.at4m);
          row.twdashcam += parseInt(el2.twdashcam);
          row.velcare += parseInt(el2.velcare);
          row.velcare_vb += parseInt(el2.velcare_vb);
          row.rnet += parseInt(el2.rnet);
          row.all += parseInt(el2.all);
        });

        if (this.events_stats.length > 0) {
          this.events_stats.unshift(row);
        }

        this.eventsSearchLoading = false;
      });
    },
    clear() {
      this.events_from = null;
      this.events_to = null;
      this.events_stats = [];
    },
    eventTypeVariant(type) {
      let variant = "";

      switch (type) {
        case "sold":
          variant = "text-success";
          break;
        case "sold_lease":
          variant = "text-success";
          break;
        case "sold_all":
          variant = "text-success";
          break;
        case "stock":
          variant = "text-warning";
          break;
        case "created":
          variant = "text-warning";
          break;
        case "transfered":
          variant = "text-warning";
          break;
        case "terminated":
          variant = "text-danger";
          break;
        case "warranty":
          variant = "text-danger";
          break;
      }
      return variant;
    },
    today() {
      this.events_from = this.getTodayRange[0];
      this.events_to = this.getTodayRange[1];

      this.search();
    },
    yesterday() {
      this.events_from = this.getYesterdayRange[0];
      this.events_to = this.getYesterdayRange[1];

      this.search();
    },
    thisWeek() {
      this.events_from = this.getThisWeekRange[0];
      this.events_to = this.getThisWeekRange[1];

      this.search();
    },
    lastWeek() {
      this.events_from = this.getLastWeekRange[0];
      this.events_to = this.getLastWeekRange[1];

      this.search();
    },
    thisMonth() {
      this.events_from = this.getThisMonthRange[0];
      this.events_to = this.getThisMonthRange[1];

      this.search();
    },
    lastMonth() {
      this.events_from = this.getLastMonthRange[0];
      this.events_to = this.getLastMonthRange[1];

      this.search();
    },
    thisYear() {
      this.events_from = this.getThisYearRange[0];
      this.events_to = this.getThisYearRange[1];

      this.search();
    },
    lastYear() {
      this.events_from = this.getLastYearRange[0];
      this.events_to = this.getLastYearRange[1];

      this.search();
    },
    thisQuarter() {
      this.events_from = this.getThisQuarterRange[0];
      this.events_to = this.getThisQuarterRange[1];

      this.search();
    },
    lastQuarter() {
      this.events_from = this.getLastQuarterRange[0];
      this.events_to = this.getLastQuarterRange[1];

      this.search();
    },
  },
  computed: {
    ...mapGetters([
      "getUserSystem",
      "getTodayRange",
      "getYesterdayRange",
      "getThisWeekRange",
      "getLastWeekRange",
      "getThisMonthRange",
      "getLastMonthRange",
      "getThisYearRange",
      "getLastYearRange",
      "getThisQuarterRange",
      "getLastQuarterRange"
    ]),
    paginatedEvents() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.events_stats.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.events_stats.length / this.perPage) || 1;
    }
  },
  watch: {
    getUserSystem: function() {
      this.today();
    }
  },
  mounted() {
    this.today();
  }
};
</script>

<style scoped>
.devices-events-container {
  padding: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-info {
  font-size: 0.875rem;
  color: #6c757d;
}

.filters-section {
  margin-top: 24px;
  padding: 16px;
  background-color: #f7fafc;
  border-radius: 8px;
}

.quick-filters {
  margin-bottom: 16px;
}

.filter-group-label {
  font-weight: 600;
  font-size: 0.875rem;
  color: #4a5568;
  margin-bottom: 12px;
}

.button-groups {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-btn {
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #e2e8f0;
  background-color: white;
  color: #4a5568;
  white-space: nowrap;
}

.filter-btn-outline {
  background-color: white;
  color: #4a5568;
}

.filter-btn-outline:hover {
  background-color: #f7fafc;
  border-color: #5469d4;
  color: #5469d4;
}

.filter-btn-active {
  background-color: #5469d4;
  border-color: #5469d4;
  color: white;
}

.filter-btn-active:hover {
  background-color: #4c51bf;
  border-color: #4c51bf;
}

.date-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.date-picker {
  flex: 1;
}

.action-buttons-row {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.action-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clear-btn {
  background-color: #fff3cd;
  border-color: #ffc107;
  color: #856404;
}

.clear-btn:hover {
  background-color: #ffc107;
  border-color: #e0a800;
  color: #fff;
}

.search-btn-green {
  background-color: #388e3c;
  color: white;
  border-color: #388e3c;
}

.search-btn-green:hover:not(:disabled) {
  background-color: #2e7d32;
  border-color: #2e7d32;
}

.search-btn-green:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.text-success {
  color: #388e3c;
  font-weight: 600;
}

.text-warning {
  color: #f57c00;
  font-weight: 600;
}

.text-danger {
  color: #d32f2f;
  font-weight: 600;
}

@media (max-width: 768px) {
  .button-groups {
    flex-direction: column;
  }

  .date-filters {
    flex-direction: column;
  }
}
</style>
